import React, { createContext, useContext, useState } from 'react';

interface TravelModeContextType {
  mode: 'home' | 'travel';
  destination: {
    city: string;
    state: string;
    zip: string;
  } | null;
  setMode: (mode: 'home' | 'travel') => void;
  setDestination: (destination: { city: string; state: string; zip: string } | null) => void;
}

const TravelModeContext = createContext<TravelModeContextType>({
  mode: 'home',
  destination: null,
  setMode: () => {},
  setDestination: () => {}
});

export const useTravelMode = () => useContext(TravelModeContext);

export const TravelModeProvider = ({ children }: { children: React.ReactNode }) => {
  const [mode, setMode] = useState<'home' | 'travel'>('home');
  const [destination, setDestination] = useState<{
    city: string;
    state: string;
    zip: string;
  } | null>(null);

  return (
    <TravelModeContext.Provider value={{ mode, destination, setMode, setDestination }}>
      {children}
    </TravelModeContext.Provider>
  );
};